// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/LegalDocuments/LegalDocumentLayout/LegalDocumentLayout.css
// module id = 423
// module chunks = 0